import * as Redux from 'redux'
import * as Form from '../../components/form'
import * as IsActive from '../../components/is_active'
import * as Request from '../../request'
import * as Constants from './constants'
import * as Types from './types'

export type FetchMemberDetailsAction = Request.RequestAction<Request.RequestOptions>
export type FetchMemberDetails = Redux.ActionCreator<FetchMemberDetailsAction>
export const fetchMemberDetails: FetchMemberDetails =
  (communityIdentifier: string, memberID: Types.MemberId) => {
    return Request.requestActionCreator(Constants.FETCH_MEMBER_DETAILS)
    ({
      method: 'GET',
      url: `${Constants.SERVER_RESOURCE}/${communityIdentifier}/${memberID}`,
    })
  }

export const updateIsActive: IsActive.UpdateStatusAction =
  (communityIdentifier: string, stateChange: IsActive.StateChange) =>
  Request.requestActionCreator(Constants.UPDATE_MEMBER_DETAILS_UPDATE_STATUS)({
    method: 'PUT',
    payload: IsActive.asUpdateBody(stateChange),
    url: `${Constants.SERVER_RESOURCE}/${communityIdentifier}/${stateChange.id}`,
  })

export type Update = (communityIdentifier: string, member: Types.Member) => Redux.Action
export const updateMemberDetails: Update = (communityIdentifier, member) =>
  Request.requestActionCreator(Constants.UPDATE_MEMBER_DETAILS)({
    method: 'PUT',
    payload: member,
    url: `${Constants.SERVER_RESOURCE}/${communityIdentifier}/${member.id}`,
  })

export const EditFormActions = Form.createActionsMap<Types.MemberDetailFormFields>(Constants.MEMBER_DETAILS_PREFIX)



// WEBPACK FOOTER //
// ./src/pages/member-details/actions.ts